import { isArray, reduce, filter } from 'lodash';

const DEFAULT_EXPIRATION = 60000 * 60 * 5; // 5h

const isKeyExpired = ({ dataByKey, expirationMillis }) =>
  dataByKey.timestamp + expirationMillis < new Date().getTime();

const purgeExpired = (key, expirationMillis = DEFAULT_EXPIRATION) => {
  const values = localStorage.getItem(key);
  const dataByKey = JSON.parse(values);
  if (isArray(dataByKey)) {
    const result = reduce(
      dataByKey,
      (acc, element, index) => {
        const expired = isKeyExpired({ dataByKey: element, expirationMillis });
        if (!expired) {
          acc.push(element);
        }
        return acc;
      },
      []
    );
    if (result.length === 0) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(result));
    }
  }
};

const init = (key) => {
  purgeExpired(key);
};

const add = ({ key, data }) => {
  const existing = get({ key });
  if (existing !== undefined) {
    if (isArray(existing)) {
      var object = { ...data, timestamp: new Date().getTime() };
      existing.push(object);
      localStorage.setItem(key, JSON.stringify(existing));
    }
  } else {
    localStorage.setItem(
      key,
      JSON.stringify([{ ...data, timestamp: new Date().getTime() }])
    );
  }
};

const get = ({ key }) => {
  purgeExpired(key);
  var item = localStorage.getItem(key);
  return item != null ? JSON.parse(item) : undefined;
};

const remove = ({ key, keyName, valueToRemove }) => {
  const existing = get({ key });
  if (existing !== undefined) {
    if (isArray(existing)) {
      const newItems = filter(existing, (data) => {
        return data[keyName] !== valueToRemove;
      });
      localStorage.setItem(key, JSON.stringify(newItems));
    }
  }
};

export default {
  init,
  set: ({ key, data }) => {
    var object = { data, timestamp: new Date().getTime() };
    localStorage.setItem(key, JSON.stringify(object));
  },
  add,
  get,
  remove,
};
